import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import S from './Social.styled'
import config from '../../../config/footer/social'
import * as Svg from '../../Svg'
import Link from '../../../modules/link/Link'
import languages from '../../../../languages'
import { addIntlKey } from '../../../utils'

const socialIconName = (social) => {
  switch (social) {
    case 'twitter':
      return 'Twitter'
    case 'instagram':
      return 'Instagram'
    case 'facebook':
      return 'FacebookF'
    case 'youtube':
      return 'YouTube'
    case 'linkedin':
      return 'LinkedIn'
    case 'vk':
      return 'Vk'
    case 'tiktok':
      return 'Tiktok'
    default:
      return
  }
}

const Social = ({
  defaultLinkTheme = 'marketing',
  socialLinks = null,
  lang = 'en',
  disableAllTargetBlank = false,
}) => {
  const customSocialLinks =
    socialLinks &&
    (Array.isArray(socialLinks)
      ? socialLinks
      : Object.entries(socialLinks).map(([social, url]) => ({ social, url })))

  const defaultSocialLinks = config[defaultLinkTheme] || []

  const intlSocial = languages[lang]
    ? languages[lang].social
    : languages.en.social
  const { twitter, instagram, facebook, youtube, linkedin, tiktok } = intlSocial
  const intlLinks = addIntlKey(
    { twitter, instagram, facebook, youtube, linkedin, tiktok },
    defaultSocialLinks,
  )

  const links = socialLinks ? customSocialLinks : intlLinks
  if (!links) return null

  return (
    <S.Social className="social-list">
      {links.map(({ social, url, intlText }) => {
        const intlSocial = lang === 'ru' && social === 'twitter' ? 'vk' : social
        const icon = socialIconName(intlSocial)
        const SvgIcon = Svg[icon]
        const to = intlText || url

        return (
          <Fragment key={social}>
            {intlText && (
              <li className="social-item">
                <Link
                  to={to}
                  className="social-link"
                  blank={disableAllTargetBlank ? false : true}
                >
                  <SvgIcon className={`social-icon ${intlSocial}`} />
                </Link>
              </li>
            )}
          </Fragment>
        )
      })}
    </S.Social>
  )
}

Social.propTypes = {
  defaultLinkTheme: PropTypes.string,
  socialLinks: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  lang: PropTypes.string,
}

export default Social
